import React, { useEffect, useState } from "react";
import Header from "../../components/ui/Header";
import ProgressHeader from "../../components/ui/ProgressHeader";
import SuccessHeader from "./components/SuccessHeader";
import RegistrationSummary from "./components/RegistrationSummary";
import DocumentActions from "./components/DocumentActions";
import NextStepsGuide from "./components/NextStepsGuide";
import SocialShare from "./components/SocialShare";
import ContactSupport from "./components/ContactSupport";
import DashboardAccess from "./components/DashboardAccess";
import registrationService from "../../utils/registrationService";

const RegistrationSuccessConfirmation = () => {
  const [registrationData, setRegistrationData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (window.top !== window.self) {
      // On mobile Safari / Chrome this can break, so disable forced replace
      console.log("Loaded inside iframe, skipping top redirect for mobile");
      // Optional: only allow on desktop
      if (!/Mobi|Android/i.test(navigator.userAgent)) {
        try {
          window.top.location.replace(window.location.href);
        } catch (e) {
          window.top.location.href = window.location.href;
        }
      }
    }
  }, []);

  // // Load data from localStorage first
  // useEffect(() => {
  //   const loadRegistrationData = async () => {
  //     try {
  //       // 1.Try API
  //       const result = await registrationService?.getUserRegistration();
  //       console.log("Puneet API result:", result);
  //       if (result?.success && result?.data) {
  //         const dbData = result?.data;
  //         console.log("Puneet DB Data:", dbData);
  //         const displayData = {
  //           registrationId: dbData?.id || "N/A",
  //           userName: dbData?.full_name || "N/A",
  //           userEmail: dbData?.email || "N/A",
  //           profile: getProfileName(dbData?.selected_profile),
  //           paymentAmount: dbData?.payment_amount || 0,
  //           registrationDate: new Date(
  //             dbData.created_at || Date.now()
  //           )?.toLocaleDateString("en-GB", {
  //             day: "2-digit",
  //             month: "long",
  //             year: "numeric",
  //           }),
  //           batchInfo: `${
  //             dbData?.selected_profile === "it-support" ? "IT" : "SD"
  //           }-Batch-${new Date()?.getFullYear()}-${new Date()?.toLocaleDateString(
  //             "en-GB",
  //             {
  //               month: "short",
  //             }
  //           )} (${
  //             dbData?.training_mode === "online"
  //               ? "Online"
  //               : "Morning 9:00 AM - 12:00 PM"
  //           })`,
  //           paymentMethod: "Razorpay Gateway",
  //           transactionId: dbData?.payment_id || "N/A",
  //           orientationDate: getOrientationDate(),
  //           batchStartDate: getBatchStartDate(),
  //         };

  //         setRegistrationData(displayData);
  //       } else {
  //         // 2.Try localStorage
  //         const formDataRaw = localStorage.getItem("registrationFormData");
  //         if (formDataRaw) {
  //           const formData = JSON.parse(formDataRaw);
  //           const displayData = {
  //             registrationId: formData?.id || "N/A",
  //             userName: formData?.fullName || "N/A",
  //             userEmail: formData?.email || "N/A",
  //             profile: getProfileName(formData?.selectedProfile),
  //             paymentAmount: formData?.paymentAmount || 0,
  //             registrationDate: new Date()?.toLocaleDateString("en-GB", {
  //               day: "2-digit",
  //               month: "long",
  //               year: "numeric",
  //             }),
  //             batchInfo: `${
  //               formData?.selectedProfile === "it-support" ? "IT" : "SD"
  //             }-Batch-${new Date()?.getFullYear()}-${new Date()?.toLocaleDateString(
  //               "en-GB",
  //               {
  //                 month: "short",
  //               }
  //             )}`,
  //             paymentMethod: "Razorpay Gateway",
  //             transactionId: formData?.paymentId || "N/A",
  //             orientationDate: getOrientationDate(),
  //             batchStartDate: getBatchStartDate(),
  //           };

  //           setRegistrationData(displayData);
  //           return;
  //         }
  //       }
  //     } catch (error) {
  //       console.error("Error loading registration data:", error);
  //       setRegistrationData(getMockData());
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   loadRegistrationData();
  // }, []);

  useEffect(() => {
  const loadRegistrationData = async () => {
    try {
      // First, check localStorage for instant render
      const formDataRaw = localStorage.getItem("registrationFormData");
      if (formDataRaw) {
        const formData = JSON.parse(formDataRaw);
        setRegistrationData({
          registrationId: formData?.id || "N/A",
          userName: formData?.fullName || "N/A",
          userEmail: formData?.email || "N/A",
          profile: getProfileName(formData?.selectedProfile),
          paymentAmount: formData?.paymentAmount || 0,
          paymentMethod: "Razorpay Gateway",
          transactionId: formData?.paymentId || "N/A",
          registrationDate: new Date().toLocaleDateString("en-GB"),
          orientationDate: getOrientationDate(),
          batchStartDate: getBatchStartDate(),
        });
      }

      // Then fetch API for latest values
      const result = await registrationService?.getUserRegistration();
      if (result?.success && result?.data) {
        const dbData = result.data;
        setRegistrationData({
          registrationId: dbData?.id,
          userName: dbData?.full_name,
          userEmail: dbData?.email,
          profile: getProfileName(dbData?.selected_profile),
          paymentAmount: dbData?.payment_amount,
          paymentMethod: "Razorpay Gateway",
          transactionId: dbData?.payment_id,
          registrationDate: new Date(dbData.created_at).toLocaleDateString("en-GB"),
          orientationDate: getOrientationDate(),
          batchStartDate: getBatchStartDate(),
        });
      }
    } catch (error) {
      console.error("Error loading registration data:", error);
    } finally {
      setLoading(false);
    }
  };

  loadRegistrationData();
}, []);


  // Profile mapping helper
  const getProfileName = (profileKey) => {
    const profiles = {
      "fullstack-developer": "Full Stack Web Developer",
      "data-analytics": "Data Analyst",
      "it-support": "IT Support Engineer",
      "mobile-app-developer": "Mobile App Developer",
      devops: "DevOps Engineer",
      "artificial-intelligence": "AI Engineer",
    };
    return profiles[profileKey] || "Software Developer";
  };

  // Helper functions for dates
  const getOrientationDate = () => {
    const orientationDate = new Date();
    orientationDate.setDate(orientationDate.getDate() + 7);
    return (
      orientationDate.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }) + ", 10:00 AM"
    );
  };

  const getBatchStartDate = () => {
    const startDate = new Date();
    startDate.setDate(startDate.getDate() + 9);
    return startDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  const getMockData = () => ({
    registrationId: "TP2025001247",
    userName: "Student",
    userEmail: "student@email.com",
    profile: "Software Developer",
    paymentAmount: 6999,
    registrationDate: new Date().toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    }),
    batchInfo: "SD-Batch-25-July (Morning 9:00 AM - 12:00 PM)",
    paymentMethod: "Razorpay Gateway",
    transactionId: "TXN789456123",
    orientationDate: getOrientationDate(),
    batchStartDate: getBatchStartDate(),
  });

  // Scroll + title
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Registration Successful - Solvarsity";
  }, []);

  // if (loading) {
  //   return (
  //     <div className="min-h-screen bg-background flex items-center justify-center">
  //       <div className="text-center">
  //         <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
  //         <p className="text-text-secondary">Loading registration details...</p>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <ProgressHeader />
      <main className="pt-32 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <SuccessHeader
            registrationId={registrationData?.registrationId}
            userName={registrationData?.userName}
          />
          <RegistrationSummary registrationData={registrationData} />
          {/* <DocumentActions
            registrationId={registrationData?.registrationId}
            userEmail={registrationData?.userEmail}
          /> */}
          <NextStepsGuide
            batchStartDate={registrationData?.batchStartDate}
            orientationDate={registrationData?.orientationDate}
          />
          <SocialShare
            registrationId={registrationData?.registrationId}
            profileType={getProfileName(registrationData?.selectedProfile)}
          />
          <ContactSupport />
          <DashboardAccess registrationId={registrationData?.registrationId} />
        </div>
      </main>
      <footer className="bg-surface border-t border-border py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <p className="text-sm text-text-secondary mb-2">
              Thank you for choosing Solvarsity for your career development
              journey.
            </p>
            <p className="text-xs text-text-secondary">
              © {2024} Solvarsity. All rights reserved. |
              <span className="mx-1">•</span>
              <a
                href="#"
                className="text-primary hover:text-primary/80 transition-smooth"
              >
                Privacy Policy
              </a>
              <span className="mx-1">•</span>
              <a
                href="#"
                className="text-primary hover:text-primary/80 transition-smooth"
              >
                Terms of Service
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default RegistrationSuccessConfirmation;
